import { Material } from '@/dtos/commons'

export class AdminIdeaUpdatesPostRequest {
  ideaId!: string
  updateBody!: string
  material?: Material
}
